import { Component, inject, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { AuthService } from '@shared/services/auth.service';
import { ThemeService } from '@shared/services/theme.service';

// PrimeNG locale imports
import { de as primeLocaleDe } from 'primelocale/js/de.js';
import { en as primeLocaleEn } from 'primelocale/js/en.js';
// Angular locale imports

import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';

registerLocaleData(localeDe);
registerLocaleData(localeEn);

import { registerLocaleData } from '@angular/common';
import { PrimeNG } from 'primeng/config';
import { Subscription } from 'rxjs';
import { ToastComponent } from '@shared/components/toast/toast.component';
import { AvailableLocale } from '@helpers/locale';

@Component({
  selector: 'app-root',
  template: '<router-outlet /><edu-toast />',
  imports: [RouterOutlet, ToastComponent],
  providers: [AuthService],
})
export class AppComponent implements OnDestroy {
  private translateService = inject(TranslocoService);
  private primeNgConfig = inject(PrimeNG);
  /** Instantiated here so the stored colour scheme applies on every page, signed in or not. */
  private theme = inject(ThemeService);

  private langChangeSubscription: Subscription;

  constructor() {
    this.langChangeSubscription = this.translateService.langChanges$.subscribe(language => {
      switch (language) {
        case AvailableLocale.DE:
          this.primeNgConfig.setTranslation(primeLocaleDe);
          break;
        case AvailableLocale.EN:
        default:
          this.primeNgConfig.setTranslation(primeLocaleEn);
          break;
      }
    });
  }

  ngOnDestroy(): void {
    this.langChangeSubscription.unsubscribe();
  }
}
